import axios from 'axios'

// Sunny16 returns 400 with a bare-string body when a DELETE targets a
// cart bundle the server has already removed (e.g. duplicate tap before
// the first response resolves). The end state matches intent, so callers
// treat it as a no-op.
export function isCartBundleNotFoundError(error: unknown): boolean {
  if (!axios.isAxiosError<string>(error)) return false
  if (error.response?.status !== 400) return false
  const body = error.response.data
  return typeof body === 'string' && body.includes('Cart Bundle not found')
}

// Sunny16 surfaces EF Core's optimistic-concurrency exception verbatim as a
// 400 when two cart-mutating writes race on the same cart row (e.g. duplicate
// taps on an Add-to-Cart CTA before the first response lands). The losing
// call's intended state matches what the winning call already produced for
// same-button rapid taps, so callers treat it as a no-op. The distinctive
// `expected to affect 1 row(s)` phrase is the most stable marker in the
// EF Core message.
export function isCartUpsertConcurrencyError(error: unknown): boolean {
  if (!axios.isAxiosError<string>(error)) return false
  if (error.response?.status !== 400) return false
  const body = error.response.data
  return typeof body === 'string' && body.includes('expected to affect 1 row(s)')
}
